import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as", "alignItems", "children", "display", "gap", "gapColumn", "gapRow"];
import styled from 'styled-components';
import { LayoutBox } from './LayoutBox';
import { makeCustomProperty } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledLayout = styled(LayoutBox).withConfig({
  displayName: "Layout__StyledLayout",
  componentId: "sc-9vwp8f-0"
})(["", " ", " ", " ", " gap:var(--layout-lib-gap-row,var(--layout-lib-gap)) var(--layout-lib-gap-column,var(--layout-lib-gap));p:last-child{margin-block-end:0;}"], ({
  $gap = 'space'
}) => `--layout-lib-gap: ${makeCustomProperty($gap)};`, ({
  $gapColumn = 'initial'
}) => `--layout-lib-gap-column: ${makeCustomProperty($gapColumn)};`, ({
  $gapRow = 'initial'
}) => `--layout-lib-gap-row: ${makeCustomProperty($gapRow)};`, ({
  $alignItems = 'start'
}) => `align-items: ${$alignItems};`);
export const Layout = _ref => {
  let {
      as,
      alignItems,
      children,
      display,
      gap,
      gapColumn,
      gapRow
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(StyledLayout, Object.assign({}, rest, {
    $alignItems: alignItems,
    $gap: gap,
    $gapColumn: gapColumn,
    $gapRow: gapRow,
    display: display,
    forwardedAs: as,
    children: children
  }));
};